import React from "react";

const RadioInput = ({
  onChange = null,
  onFocus = null,
  onBlur = null,
  onClick = null,
  label = null,
  placeholder = "",
  classes = "",
  refs = () => "",
  id = `input-${Date.now()}`,
  shouldAutoFocus = false,
  name = "radio-input",
  value = "",
  checked = false,
  disabled = false,
  inputClasses = "",
  autoComplete = "",
}) => {
  return (
    <div className={`custom-radio ${classes}`}>
      <input
        type="radio"
        placeholder={placeholder}
        className={inputClasses}
        name={name}
        id={id}
        ref={(input) => refs(input)}
        disabled={disabled}
        autoFocus={shouldAutoFocus}
        value={value}
        checked={checked}
        autoComplete={autoComplete}
        onChange={(e) =>
          typeof onChange == "function"
            ? onChange({ name: e.target.name, value: e.target.value, checked: e.target.checked })
            : ""
        }
        onClick={(e) => (typeof onClick == "function" ? onClick(e) : "")}
        onFocus={() => (typeof onFocus == "function" ? onFocus() : "")}
        onBlur={() => (typeof onBlur == "function" ? onBlur() : "")}
      />
      {label && (
        <label htmlFor={id} className={label.classes}>
          {label.content}
        </label>
      )}
    </div>
  );
};

export default RadioInput;
